import React from 'react';
import { useLocation } from 'react-router-dom';

const ThankYouPage = () => {
  const location = useLocation();
  const { productName, productDescription, productPhoto, amount } = location.state || {};

  if (!productName) {
    return <div>No data available. Please return to the home page.</div>;
  }

  return (
    <div>
      <h1>Thank You for Your Payment!</h1>
      <img src={productPhoto} alt={productName} style={{ width: '300px' }} />
      <p>Product: {productName}</p>
      <p>Description: {productDescription}</p>
      <p>Amount Paid: ${amount}</p>
    </div>
  );
};

export default ThankYouPage;
